export const ParamsData = ({userData, audioFile, customName}) => {

    console.log("userData", userData);
    console.log("audioFile", audioFile);
    console.log("customName", customName);

  const timestamp = new Date().getTime();
  const fileExtension = audioFile.name.split(".").pop();
  const fileName = `${userData.id}_${timestamp}_${customName}.${fileExtension}`;
  const metadata = {
    "x-amz-meta-user-id": userData.id + "" || "",
    "x-amz-meta-user-firstname": userData.first_name || "",
    "x-amz-meta-user-lastname": userData.last_name || "",
    "x-amz-meta-user-email": userData.email || "",
    "x-amz-meta-user-country": userData.country || "",
    "x-amz-meta-user-city": userData.city || "",
    "x-amz-meta-user-role": userData.role?.join(", ") || "",
    "x-amz-meta-user-phone": userData.phone || "",
    "x-amz-meta-user-birthday": userData.birthday || "",
    "x-amz-meta-user-timestamp": timestamp.toString(),
  };
  const params = {
    Bucket: "mentu-class-audios",
    Key: `original/${fileName}`,
    Body: audioFile,
    ContentType: audioFile.type,
    Metadata: metadata,
  };

  return params;
}